import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Promotion} from "../models/promotion";
import {PromotionService} from "../services/promotion.service";

@Injectable({
    providedIn: 'root'
})
export class PromotionItemResolver  {

    constructor(
        private _promotionService: PromotionService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._promotionService.getItemAPI(parseInt(route.paramMap.get('id')));
    }
}
